import { useContext } from 'react';
import { AuthContext } from '../auth';

export interface DefaultFilters {
  defaultPrescriberNames: string[];
  defaultPrescriberNpis: string[];
}

/**
 * Hook to extract default prescriber filters from the current user in AuthContext.
 * Returns default prescriber names and provider NPIs.
 */
export function useDefaultFilters(): DefaultFilters {
  const authContext = useContext(AuthContext);
  const providers = authContext.user?.default_filters?.providers || [];

  return {
    defaultPrescriberNames: providers.map((p) => p.name),
    defaultPrescriberNpis: providers.map((p) => p.npi),
  };
}
